import {
    AvCheckFormData,
    CmsPageContentIdentifier,
    CmsPageContentType,
    ReduxStateType,
} from "@/types/av-check";
import React from "react";
import {connect} from "react-redux";
import {useField} from "react-final-form-hooks";
import {FormApi} from "final-form";
import {buildCheckPersonAndUsecaseData, pushToTefDataLayer} from "@/services/tracking";

export interface StateProps {
    cmsContent: CmsPageContentType,
}

export interface HouseholdConfiguratorProps {
    form: FormApi<AvCheckFormData, Partial<AvCheckFormData>>,
}

const HouseholdConfigurator = ({
    cmsContent,
    form,
                                } : StateProps & HouseholdConfiguratorProps) => {

    const numberOfPersons = useField('numberOfPersons', form);
    const usageTypeOnlineGaming = useField('usageTypeOnlineGaming', form);
    const usageTypeVideoStreaming = useField('usageTypeVideoStreaming', form);
    const usageTypeHomeOffice = useField('usageTypeHomeOffice', form);

    const onHouseholdConfiguratorChange = (e: React.ChangeEvent<HTMLInputElement>)  => {

        let nOPTrackingInfo = numberOfPersons.input.value;

        const uTTrackingInfo = [
            ...(usageTypeVideoStreaming.input.value? ['streaming']:[]),
            ...(usageTypeHomeOffice.input.value? ['HO']:[]),
            ...(usageTypeOnlineGaming.input.value? ['OGA']:[]),
        ];

        const {target} = e ;

        const handleChange = (targetName:string) => {

          const updateTarget= {
              [numberOfPersons.input.name]:  () => {
                    numberOfPersons.input.onChange(e);
                    nOPTrackingInfo = target.value;
                },
              [usageTypeVideoStreaming.input.name]:  () => {
                  usageTypeVideoStreaming.input.onChange(e);
                  target.checked ? uTTrackingInfo.splice(uTTrackingInfo.length,0,'streaming'):
                    uTTrackingInfo.splice(uTTrackingInfo.indexOf('streaming'),1);
              },
              [usageTypeHomeOffice.input.name]:  () => {
                  usageTypeHomeOffice.input.onChange(e);
                  target.checked ? uTTrackingInfo.splice(uTTrackingInfo.length,0,'HO'):
                    uTTrackingInfo.splice(uTTrackingInfo.indexOf('HO'),1);
              },
              [usageTypeOnlineGaming.input.name]:  () => {
                  usageTypeOnlineGaming.input.onChange(e);
                  target.checked ? uTTrackingInfo.splice(uTTrackingInfo.length,0,'OGA'):
                    uTTrackingInfo.splice(uTTrackingInfo.indexOf('OGA'),1);
              },
            }
            updateTarget[targetName]();
        }

        handleChange(target.name);

        pushToTefDataLayer(window, buildCheckPersonAndUsecaseData(
          nOPTrackingInfo, uTTrackingInfo.length ? uTTrackingInfo.join('|') : 'undefined'));
    }


    // @ts-ignore
    return (
        <div className="form-group text-left">
            <h3>{cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorHeadline] }</h3>
            <div className="form-group form-group-line">
                {cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorIntroText]}
            </div>
            <div className="switcher-box" style={{ marginBottom: '20px' , display: 'flex', maxWidth: 'fit-content'}}>
                <div className="switcher-item" style={{ flexBasis: '100px' , minWidth: '100px', maxWidth: '150px'}}>
                    <input
                        {...numberOfPersons.input}
                        id="noselection"
                        type="radio"
                        disabled={false}
                        value={'no-selection'}
                        checked={numberOfPersons.input.value === 'no-selection'}
                        onChange={onHouseholdConfiguratorChange}
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="noselection"> {cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorSwitcherNoInfo]}</label>
                </div>
                <div className="switcher-item" style={{ flexBasis: '40px' , minWidth: '40px', maxWidth: '100px', flexGrow: 1}}>
                    <input
                        {...numberOfPersons.input}
                        id="1person"
                        type="radio"
                        disabled={false}
                        value={'1'}
                        checked={numberOfPersons.input.value === '1'}
                        onChange={onHouseholdConfiguratorChange}
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="1person">1</label>
                </div>
                <div className="switcher-item" style={{ flexBasis: '40px' , minWidth: '40px', maxWidth: '100px', flexGrow: 1}}>
                    <input
                        {...numberOfPersons.input}
                        id="2person"
                        type="radio"
                        disabled={false}
                        value={'2'}
                        checked={numberOfPersons.input.value === '2'}
                        onChange={onHouseholdConfiguratorChange}
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="2person">2</label>
                </div>
                <div className="switcher-item" style={{ flexBasis: '40px' , minWidth: '40px', maxWidth: '100px', flexGrow: 1}}>
                    <input
                        {...numberOfPersons.input}
                        id="3person"
                        type="radio"
                        disabled={false}
                        value={'3'}
                        checked={numberOfPersons.input.value === '3'}
                        onChange={onHouseholdConfiguratorChange}
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="3person">3</label>
                </div>
                <div className="switcher-item" style={{ flexBasis: '40px' , minWidth: '40px', maxWidth: '100px', flexGrow: 1}}>
                    <input
                        {...numberOfPersons.input}
                        id="4person"
                        type="radio"
                        disabled={false}
                        value={'4'}
                        checked={numberOfPersons.input.value === '4'}
                        onChange={onHouseholdConfiguratorChange}
                    />
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="4person">4+</label>
                </div>
            </div>
            <div className="form-group form-group-line">
                {cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorUsageText]}
            </div>
            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '20px' }}>
                <li>
                    <div className="checkbox">
                        <input
                            {...usageTypeVideoStreaming.input}
                            type="checkbox"
                            id={usageTypeVideoStreaming.input.name}
                            checked={usageTypeVideoStreaming.input.value}
                            onChange={onHouseholdConfiguratorChange}
                        />
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label
                            htmlFor={usageTypeVideoStreaming.input.name}
                            dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorUsageFirstCheckbox] }}
                        />
                    </div>
                </li>
                <li>
                    <div className="checkbox">
                        <input
                            {...usageTypeHomeOffice.input}
                            type="checkbox"
                            id={usageTypeHomeOffice.input.name}
                            checked={usageTypeHomeOffice.input.value}
                            onChange={onHouseholdConfiguratorChange}
                        />
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label  htmlFor={usageTypeHomeOffice.input.name}>
                            {cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorUsageSecondCheckbox]}
                        </label>
                    </div>
                </li>
                <li>
                    <div className="checkbox">
                        <input
                            {...usageTypeOnlineGaming.input}
                            type="checkbox"
                            id={usageTypeOnlineGaming.input.name}
                            checked={usageTypeOnlineGaming.input.value}
                            onChange={onHouseholdConfiguratorChange}
                        />
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label htmlFor={usageTypeOnlineGaming.input.name}>
                            {cmsContent[CmsPageContentIdentifier.HouseholdConfiguratorUsageThirdCheckbox]}
                        </label>
                    </div>
                </li>
            </ul>
        </div>
)
}

const mapStateToProps = (state: ReduxStateType) => ({
    cmsContent: state.cmsContent,
});

export default connect(mapStateToProps)(HouseholdConfigurator);